import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AddPost.css';

const ARTICLE_CATEGORIES = [
  'Understanding estimates',
  'Common procedures',
  'Emergency care',
  'Dental care',
  'Surgery questions',
  'Pet insurance',
  'How to compare hospitals',
  'Privacy and uploading',
  'General'
];

const AddPost = () => {
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('Understanding estimates');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    setImage(e.target.files[0] || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('category', category);
    formData.append('content', content);
    if (image) {
      formData.append('image', image);
    }

    try {
      const response = await fetch('/api/posts', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      if (response.ok) {
        navigate('/advice');
      } else {
        const data = await response.json().catch(() => ({}));
        setError(data.message || 'Unable to create article.');
      }
    } catch (error) {
      console.error('Error creating post', error);
      setError('Unable to create article.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="add-post-page">
      <section className="add-post-container">
        <div className="add-post-header">
          <p>Admin</p>
          <h1>Add Advice Article</h1>
          <span>Create practical guidance that helps pet owners read bills, compare estimates, and prepare for care.</span>
        </div>

        <form onSubmit={handleSubmit} className="add-post-form">
          <label className="form-group" htmlFor="title">
            Title
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="form-control"
            placeholder="Example: What to ask before approving a surgery estimate"
          />
          </label>

          <label className="form-group" htmlFor="category">
            Category
          <select
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
            className="form-control"
          >
            {ARTICLE_CATEGORIES.map(articleCategory => (
              <option key={articleCategory} value={articleCategory}>{articleCategory}</option>
            ))}
          </select>
          </label>

          <label className="form-group" htmlFor="content">
            Article content
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            className="form-control"
            placeholder="Write in plain language. Short paragraphs are easiest to scan on mobile."
          ></textarea>
          </label>

          <label className="form-group" htmlFor="image">
            Optional image
          <input
            type="file"
            id="image"
            onChange={handleImageChange}
            className="form-control-file"
            accept="image/*"
          />
            {image && <span className="selected-file">{image.name}</span>}
          </label>

          {error && <div className="add-post-error">{error}</div>}

          <div className="add-post-actions">
            <button type="button" className="secondary-button" onClick={() => navigate('/advice')}>Cancel</button>
            <button type="submit" className="primary-button" disabled={saving}>
              {saving ? 'Publishing...' : 'Publish article'}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default AddPost;
